import { useState, useRef } from "react";
import "./editorialForms.css";

const genres = [
  { id: "action", name: "Ação" },
  { id: "comedy", name: "Comédia" },
  { id: "drama", name: "Drama" },
  { id: "horror", name: "Terror" },
  { id: "romance", name: "Romance" },
  { id: "scifi", name: "Ficção Científica" },
  { id: "documentary", name: "Documentário" },
  { id: "animation", name: "Animação" },
  { id: "thriller", name: "Suspense" },
  { id: "fantasy", name: "Fantasia" },
];

const contentTypes = [
  { id: "movie", name: "Filme" },
  { id: "series", name: "Série" },
  { id: "documentary", name: "Documentário" },
  { id: "short", name: "Curta" },
];

const maturityRatings = [
  { id: "L", name: "Livre" },
  { id: "10", name: "10 anos" },
  { id: "12", name: "12 anos" },
  { id: "14", name: "14 anos" },
  { id: "16", name: "16 anos" },
  { id: "18", name: "18 anos" },
];

export default function NetflixForm({ data, onChange }) {
  const [cast, setCast] = useState(data?.cast?.join(", ") || "");
  const [selectedGenres, setSelectedGenres] = useState(data?.genre || []);
  const [subtitles, setSubtitles] = useState(data?.subtitles || []);
  const [audioTracks, setAudioTracks] = useState(data?.audioTracks || []);
  const [subtitleForm, setSubtitleForm] = useState({ language: "", label: "", url: "" });
  const [audioForm, setAudioForm] = useState({ language: "", label: "", url: "" });
  const posterInputRef = useRef(null);
  const videoInputRef = useRef(null);

  const handlePosterChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        onChange({
          ...data,
          posterImage: file,
          posterImageName: file.name,
          posterImagePreview: reader.result,
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      onChange({ ...data, videoFile: file, videoFileName: file.name });
    }
  };

  const handleCastChange = (e) => {
    const value = e.target.value;
    setCast(value);
    const castArray = value
      .split(",")
      .map((actor) => actor.trim())
      .filter((actor) => actor.length > 0);
    onChange({ ...data, cast: castArray });
  };

  const handleGenreToggle = (genreId) => {
    const newGenres = selectedGenres.includes(genreId)
      ? selectedGenres.filter((g) => g !== genreId)
      : [...selectedGenres, genreId];
    setSelectedGenres(newGenres);
    onChange({ ...data, genre: newGenres });
  };

  const addSubtitle = () => {
    if (!subtitleForm.language || !subtitleForm.url) return;
    const next = [...subtitles, subtitleForm];
    setSubtitles(next);
    setSubtitleForm({ language: "", label: "", url: "" });
    onChange({ ...data, subtitles: next });
  };

  const removeSubtitle = (idx) => {
    const next = subtitles.filter((_, i) => i !== idx);
    setSubtitles(next);
    onChange({ ...data, subtitles: next });
  };

  const addAudio = () => {
    if (!audioForm.language || !audioForm.url) return;
    const next = [...audioTracks, audioForm];
    setAudioTracks(next);
    setAudioForm({ language: "", label: "", url: "" });
    onChange({ ...data, audioTracks: next });
  };

  const removeAudio = (idx) => {
    const next = audioTracks.filter((_, i) => i !== idx);
    setAudioTracks(next);
    onChange({ ...data, audioTracks: next });
  };

  return (
    <div className="editorial_form netflix_form">
      <div className="editorial_form_section">
        <label>
          Poster <span className="required">*</span>
        </label>
        <div className="file_upload_area" onClick={() => posterInputRef.current?.click()}>
          <input
            ref={posterInputRef}
            type="file"
            accept="image/*,.jpg,.jpeg,.png,.webp"
            onChange={handlePosterChange}
            style={{ display: "none" }}
          />
          {data?.posterImagePreview ? (
            <div className="file_selected sticker_preview">
              <img src={data.posterImagePreview} alt="Poster" style={{ maxWidth: "120px", maxHeight: "200px", borderRadius: "8px" }} />
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  onChange({ ...data, posterImage: null, posterImageName: null, posterImagePreview: null });
                }}
                className="file_remove_btn"
              >
                ✕
              </button>
            </div>
          ) : (
            <div className="file_placeholder">
              <svg viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
                <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
              </svg>
              <p>Clique para fazer upload do poster</p>
              <span>JPG, PNG, WEBP</span>
            </div>
          )}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Vídeo Trailer (opcional)</label>
        <div className="file_upload_area" onClick={() => videoInputRef.current?.click()}>
          <input
            ref={videoInputRef}
            type="file"
            accept="video/*,.mp4,.mov,.avi,.mkv,.webm"
            onChange={handleVideoChange}
            style={{ display: "none" }}
          />
          {data?.videoFileName ? (
            <div className="file_selected">
              <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z" />
              </svg>
              <span>{data.videoFileName}</span>
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  onChange({ ...data, videoFile: null, videoFileName: null });
                }}
                className="file_remove_btn"
              >
                ✕
              </button>
            </div>
          ) : (
            <div className="file_placeholder">
              <svg viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
                <path d="M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z" />
              </svg>
              <p>Clique para fazer upload do trailer</p>
              <span>MP4, MOV, AVI, MKV, WEBM</span>
            </div>
          )}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>
          Título <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Nome do filme ou série"
          value={data?.title || ""}
          onChange={(e) => onChange({ ...data, title: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Sinopse</label>
        <textarea
          placeholder="Descrição do conteúdo..."
          value={data?.synopsis || ""}
          onChange={(e) => onChange({ ...data, synopsis: e.target.value })}
          rows={3}
          maxLength={1000}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Tipo de Conteúdo</label>
          <select
            value={data?.contentType || ""}
            onChange={(e) => onChange({ ...data, contentType: e.target.value })}
          >
            <option value="">Selecione</option>
            {contentTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
        </div>
        <div className="editorial_form_section">
          <label>Classificação</label>
          <select
            value={data?.maturityRating || ""}
            onChange={(e) =>
              onChange({ ...data, maturityRating: e.target.value })
            }
          >
            <option value="">Selecione</option>
            {maturityRatings.map((rating) => (
              <option key={rating.id} value={rating.id}>
                {rating.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      {data?.contentType === "series" && (
        <div className="editorial_form_row">
          <div className="editorial_form_section">
            <label>Temporada</label>
            <input
              type="number"
              placeholder="Nº"
              value={data?.season || ""}
              onChange={(e) =>
                onChange({ ...data, season: parseInt(e.target.value) || 0 })
              }
              min="1"
            />
          </div>
          <div className="editorial_form_section">
            <label>Episódio</label>
            <input
              type="number"
              placeholder="Nº"
              value={data?.episode || ""}
              onChange={(e) =>
                onChange({ ...data, episode: parseInt(e.target.value) || 0 })
              }
              min="1"
            />
          </div>
          <div className="editorial_form_section">
            <label>Título do Ep.</label>
            <input
              type="text"
              placeholder="Nome do episódio"
              value={data?.episodeTitle || ""}
              onChange={(e) =>
                onChange({ ...data, episodeTitle: e.target.value })
              }
            />
          </div>
        </div>
      )}

      <div className="editorial_form_section">
        <label>Gêneros</label>
        <div className="genre_chips">
          {genres.map((genre) => (
            <button
              key={genre.id}
              type="button"
              className={`genre_chip ${
                selectedGenres.includes(genre.id) ? "selected" : ""
              }`}
              onClick={() => handleGenreToggle(genre.id)}
            >
              {genre.name}
            </button>
          ))}
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Diretor</label>
          <input
            type="text"
            placeholder="Nome do diretor"
            value={data?.director || ""}
            onChange={(e) => onChange({ ...data, director: e.target.value })}
          />
        </div>
        <div className="editorial_form_section">
          <label>Ano</label>
          <input
            type="number"
            placeholder="2024"
            value={data?.releaseYear || ""}
            onChange={(e) =>
              onChange({ ...data, releaseYear: parseInt(e.target.value) || 0 })
            }
            min="1900"
            max="2030"
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Link do Trailer</label>
        <input
          type="text"
          placeholder="URL do trailer (opcional)"
          value={data?.trailerUrl || ""}
          onChange={(e) => onChange({ ...data, trailerUrl: e.target.value })}
        />
        <span className="editorial_form_hint">Será usado como fallback ou no modo "Assistir trailer"</span>
      </div>

      <div className="editorial_form_section">
        <label>Elenco</label>
        <input
          type="text"
          placeholder="Ator1, Ator2, Ator3"
          value={cast}
          onChange={handleCastChange}
        />
        <span className="editorial_form_hint">Separe os nomes por vírgula</span>
      </div>

      <div className="editorial_form_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z" />
        </svg>
        <span>Faça upload do vídeo/trailer usando o botão de mídia</span>
      </div>

      <div className="editorial_form_section">
        <label>Legendas</label>
        <div className="editorial_form_row">
          <input
            type="text"
            placeholder="pt-BR"
            value={subtitleForm.language}
            onChange={(e) => setSubtitleForm({ ...subtitleForm, language: e.target.value })}
          />
          <input
            type="text"
            placeholder="Português"
            value={subtitleForm.label}
            onChange={(e) => setSubtitleForm({ ...subtitleForm, label: e.target.value })}
          />
          <input
            type="text"
            placeholder="URL da legenda (.vtt)"
            value={subtitleForm.url}
            onChange={(e) => setSubtitleForm({ ...subtitleForm, url: e.target.value })}
          />
          <button type="button" className="editorial_add_btn" onClick={addSubtitle}>Adicionar</button>
        </div>
        {subtitles.length > 0 && (
          <ul className="editorial_list">
            {subtitles.map((s, idx) => (
              <li key={`${s.language}-${idx}`}>
                <span>{s.label || s.language}</span>
                <span className="muted">{s.url}</span>
                <button type="button" className="editorial_remove_btn" onClick={() => removeSubtitle(idx)}>Remover</button>
              </li>
            ))}
          </ul>
        )}
        <div className="editorial_form_row">
          <div className="editorial_form_section">
            <label>Legenda padrão</label>
            <select
              value={data?.defaultSubtitle || ""}
              onChange={(e) => onChange({ ...data, defaultSubtitle: e.target.value })}
            >
              <option value="">Sem legenda automática</option>
              {subtitles.map((s) => (
                <option key={s.language} value={s.language}>{s.label || s.language}</option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Trilhas de Áudio</label>
        <div className="editorial_form_row">
          <input
            type="text"
            placeholder="pt-BR"
            value={audioForm.language}
            onChange={(e) => setAudioForm({ ...audioForm, language: e.target.value })}
          />
          <input
            type="text"
            placeholder="Português"
            value={audioForm.label}
            onChange={(e) => setAudioForm({ ...audioForm, label: e.target.value })}
          />
          <input
            type="text"
            placeholder="URL da trilha (vídeo/áudio)"
            value={audioForm.url}
            onChange={(e) => setAudioForm({ ...audioForm, url: e.target.value })}
          />
          <button type="button" className="editorial_add_btn" onClick={addAudio}>Adicionar</button>
        </div>
        {audioTracks.length > 0 && (
          <ul className="editorial_list">
            {audioTracks.map((a, idx) => (
              <li key={`${a.language}-${idx}`}>
                <span>{a.label || a.language}</span>
                <span className="muted">{a.url}</span>
                <button type="button" className="editorial_remove_btn" onClick={() => removeAudio(idx)}>Remover</button>
              </li>
            ))}
          </ul>
        )}
        <div className="editorial_form_row">
          <div className="editorial_form_section">
            <label>Áudio padrão</label>
            <select
              value={data?.defaultAudio || ""}
              onChange={(e) => onChange({ ...data, defaultAudio: e.target.value })}
            >
              <option value="">Áudio principal</option>
              {audioTracks.map((a) => (
                <option key={a.language} value={a.language}>{a.label || a.language}</option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
}
